import { RefreshCw, Plus, Pencil, Trash2, Layers } from "lucide-react";

export default function MembershipTab({ ctx }) {
  const { settings, updateMode, loading, loadAll, token, divisions, setEditingDiv, archiveDivision } = ctx;
  return (
    <>
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-white">Membership</h1>
        <button data-testid="membership-refresh-btn" onClick={() => loadAll(token)} disabled={loading}
          className="inline-flex items-center gap-2 text-sm font-bold text-white/70 hover:text-white border border-white/15 rounded-full px-4 py-2.5 transition-colors">
          <RefreshCw size={15} className={loading ? "animate-spin" : ""} /> Refresh
        </button>
      </div>

      {/* Registration mode */}
      <div className="mt-8 rounded-2xl bg-white/5 border border-white/10 p-6">
        <p className="text-sm font-bold uppercase tracking-wider text-white/40">Website Registration Mode</p>
        <p className="mt-2 text-sm font-medium text-white/50">Controls how the public site behaves. Changes apply immediately.</p>
        <div className="mt-5 flex flex-wrap gap-2.5">
          {[
            ["waitlist_only", "Waitlist Only"],
            ["registration_open", "Registration Open"],
            ["registration_closed", "Registration Closed"],
          ].map(([mode, label]) => (
            <button
              key={mode}
              data-testid={`mode-${mode}`}
              onClick={() => updateMode(mode)}
              disabled={loading}
              className={`rounded-full px-5 py-2.5 text-sm font-bold border-2 transition-colors ${
                settings?.registration_mode === mode
                  ? "border-[#2563EB] bg-[#2563EB] text-white"
                  : "border-white/15 text-white/70 hover:border-white/30"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Divisions */}
      <div className="mt-8 flex items-center justify-between gap-4">
        <h2 className="text-xl font-extrabold tracking-tight text-white">Divisions &amp; Capacity</h2>
        <button data-testid="add-division-btn" onClick={() => setEditingDiv({ name: "", capacity: 8, sort_order: divisions.length, filled_adjustment: 0, monthly_price: 199, status: "active" })}
          className="inline-flex items-center gap-2 text-sm font-bold text-white bg-[#2563EB] hover:bg-[#1d4fd7] rounded-full px-5 py-2.5 transition-colors">
          <Plus size={16} /> Add Division
        </button>
      </div>

      <div className="mt-5 space-y-3">
        {divisions.length === 0 && <p className="text-white/40 font-medium">No divisions yet. Add one to start.</p>}
        {divisions.map((d) => (
          <div key={d.id} data-testid={`admin-division-${d.id}`} className="rounded-2xl bg-white/5 border border-white/10 p-5 md:p-6 flex flex-wrap items-center justify-between gap-4">
            <div>
              <div className="flex items-center gap-3">
                {d.status === "archived" ? (
                  <span className="inline-block rounded-full px-3 py-1 text-xs font-bold uppercase bg-white/5 text-white/40">Archived</span>
                ) : d.full ? (
                  <span className="inline-block rounded-full px-3 py-1 text-xs font-bold uppercase bg-red-500/20 text-red-300">Full</span>
                ) : (
                  <span className="inline-block rounded-full px-3 py-1 text-xs font-bold uppercase bg-[#2563EB] text-white">Open</span>
                )}
                <p className="text-lg font-bold text-white flex items-center gap-2"><Layers size={16} className="text-[#2563EB]" /> {d.name}</p>
              </div>
              <p className="mt-2 text-sm font-medium text-white/50">
                {d.filled} / {d.capacity} filled · {d.remaining} remaining · {d.member_count} paid members
                {d.filled_adjustment ? ` · +${d.filled_adjustment} manual` : ""}
                {d.monthly_price != null ? ` · $${d.monthly_price}/mo` : ""}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button data-testid={`edit-division-${d.id}`} onClick={() => setEditingDiv({ ...d })}
                className="inline-flex items-center gap-1.5 text-sm font-bold text-white/70 hover:text-white border border-white/15 rounded-full px-4 py-2 transition-colors">
                <Pencil size={14} /> Edit
              </button>
              {d.status !== "archived" && (
                <button data-testid={`archive-division-${d.id}`} onClick={() => archiveDivision(d.id)}
                  className="inline-flex items-center gap-1.5 text-sm font-bold text-red-300 hover:text-red-200 border border-white/15 rounded-full px-4 py-2 transition-colors">
                  <Trash2 size={14} /> Archive
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
